import React from 'react';

import { urls } from '@/constants';
import { getOrganizations } from '@/services/api/organizations';

import Typography from '@/components/Typography';
import ActivityBadge from '@/components/Badge/ActivityBadge';
import PaginatedTable from '@/components/ui/paginated';
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Card, CardContent } from '@/components/ui/card';

const OrganizationsListPage: React.FC = () => (
  <div className="space-y-4">
    <div className="flex">
      <Typography is="h1" size="2xl" weight="bold">
        Organizations
      </Typography>
    </div>

    <Card>
      <CardContent>
        <PaginatedTable
          source={(page, count) => getOrganizations(page, count)}
          renderHeader={() => (
            <TableHeader>
              <TableRow>
                <TableHead>Organization</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
          )}
        >
          {(organizations) => (
            <TableBody>
              {organizations.map((organization) => (
                <TableRow key={organization.id} url={urls.organizations.detail.get(organization.id)}>
                  <TableCell>
                    <div className="flex space-x-4 align-middle">
                      <img src={organization.thumbnailUrl} className="object-cover w-12 h-12 bg-gray-200 rounded-lg" />
                      <div>
                        <p className="text-base font-medium text-foreground">{organization.name}</p>
                        <p className="text-sm text-secondary-foreground">{organization.address}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <ActivityBadge active={organization.active} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </PaginatedTable>
      </CardContent>
    </Card>
  </div>
);

export default OrganizationsListPage;
